import { render } from "./px-empty-message.vue?vue&type=template&id=300218ee&scoped=true&ts=true"
import script from "./px-empty-message.vue?vue&type=script&lang=ts"
export * from "./px-empty-message.vue?vue&type=script&lang=ts"

import "./px-empty-message.vue?vue&type=style&index=0&id=300218ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300218ee"]])

export default __exports__